import { render, staticRenderFns } from "./VariantManagerV2.vue?vue&type=template&id=23e3b7a9&scoped=true&"
import script from "./VariantManagerV2.vue?vue&type=script&lang=js&"
export * from "./VariantManagerV2.vue?vue&type=script&lang=js&"
import style0 from "./VariantManagerV2.vue?vue&type=style&index=0&id=23e3b7a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e3b7a9",
  null
  
)

export default component.exports